import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
import ForumIcon from '@mui/icons-material/Forum';

export { TicketsPage } from './TicketsPage';
export { ConversationsPage } from './ConversationsPage';
export const TicketsIcon = ConfirmationNumberIcon;
export const ConversationsIcon = ForumIcon;
